export default __webpack_public_path__ + "static/media/FAQ-contact.842900ff.svg";